export default __webpack_public_path__ + "static/media/Business.01bd505d.mp4";